import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';



const FormActions = ({ onSave, isEditMode, hasChanges, saving = false }) => {
  const navigate = useNavigate();

  return (
    <div className="sticky bottom-0 bg-white border-t border-border px-6 py-4 flex justify-end gap-4 z-10">
      <button
        type="button"
        onClick={() => navigate('/admin-dashboard')}
        className="btn-secondary"
        disabled={saving}
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSave}
        className="btn-primary"
        disabled={!hasChanges || saving}
      >
        {saving ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Saving...
          </>
        ) : (
          <>
            {isEditMode ? 'Update Company' : 'Create Company'}
          </>
        )}
      </button>
    </div>
  );
};

export default FormActions;